export enum AuthErrorType {
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  PASSWORD_POLICY = 'PASSWORD_POLICY',
  // 環境変数にCLIENT_SECRETが設定されていない
  NOTFOUND_CLIENT_SECRET = 'NOTFOUND_CLIENT_SECRET',

  // APIレスポンスが不正
  INVALID_RESPONSE_RESULT = 'INVALID_RESPONSE_RESULT',
  // IdToken不正
  INVALID_RESPONSE_ID_TOKEN = 'INVALID_RESPONSE_ID_TOKEN',
  // リフレッシュトークンなし
  INVALID_RESPONSE_REFRESH_TOKEN = 'INVALID_RESPONSE_REFRESH_TOKEN',

  // 入力エラー
  INVALID_PARAMETER_EMPTY = 'INVALID_PARAMETER_EMPTY',
  // 認証エラー
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',

  // サインアップ時のパラメータエラー
  SIGNUP_PARAMETER = 'SIGNUP_PARAMETER',
  // サインアップ時のパスワードエラー
  SIGNUP_PASSWORD = 'SIGNUP_PASSWORD',
  // サインアップ時に同じユーザ名（メールアドレス）がある場合
  SIGNUP_USER_EXISTS = 'SIGNUP_USER_EXISTS',
  SIGNUP_OTHER = 'SIGNUP_OTHER'
}

export class AuthError extends Error {
  constructor(public type: AuthErrorType) {
    super(type)
  }
}
